import router from "./index";

export default [
  {
    path: "/login",
    component: () => import('../views/Login/Login'),
    beforeEnter: (to, from, next) => {
      if (!router.app.$cookies.get("islogin"))
        next();
      else
        router.replace("/home");
    },
    meta: {
      title: '登录'
    },
    children: [
      {
        path: '/',
        redirect: 'teacher'
      },
      {
        path: 'student',
        component: () => import('../views/Login/student/Student'),
        meta: {
          title: '学生登录'
        },
      },
      {
        path: 'teacher',
        component: () => import('../views/Login/teacher/Teacher'),
        meta: {
          title: '教师登录'
        },
      },
      {
        path: 'admin',
        component: () => import('../views/Login/admin/Admin'),
        meta: {
          title: '管理员登录'
        },
      }
    ]
  },
]
